import React from 'react'
import { withRouter } from 'react-router-dom'
import iconEdit from '../../../../assets/icons/edit-black.svg'
import iconDelete from '../../../../assets/icons/delete-black.svg'
import './article-type.styles.scss'
import Loading from '../../../../components/loading/loading.component'
import Worker from './worker'

class ArticleType extends React.Component {

    constructor(){
        super()
        this.worker = Worker(this)
        this.state = this.worker.getDefaultState()
    }

    onDelete = () => this.worker.deleteArticleType()

    render(){
        return (
            <div className="article-type">
                <div>
                    <h4>{this.props.name}</h4>
                    <p>Created: {new Date(this.props.created).toString("dd MMM, yyyy")}</p>
                    <p>Updated: {new Date(this.props.updated).toString("dd MMM, yyyy")}</p>
                </div>
                <div>
                    <img alt="" src={iconEdit} onClick={() => this.props.history.push('/article/article-types/edit/' + this.props.id)} />
                    {
                        this.state.deleting ? <Loading /> : <img alt="" src={iconDelete} onClick={this.onDelete} />
                    }
                </div>
            </div>
        )
    }
}

export default withRouter(ArticleType)